import React from 'react';

interface FilterLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode;
}

export const FilterLabel: React.FC<FilterLabelProps> = ({
  children,
  className = '',
  ...props
}) => {
  return (
    <label
      className={`ml-2 cursor-pointer text-gray-600 hover:text-gray-500 dark:text-gray-300 dark:hover:text-gray-200 ${className}`}
      {...props}
    >
      {children}
    </label>
  );
};
